import React from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

// Catches a crash inside one page so the header, footer and the rest of the
// site keep working, instead of React unmounting everything (a blank page).
class Boundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { failed: false };
    }

    static getDerivedStateFromError() {
        return { failed: true };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error('Page error:', error, info && info.componentStack);
    }

    render() {
        if (!this.state.failed) return this.props.children;
        return (
            <Box role="alert" sx={{ textAlign: 'center', py: 12, px: 2 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Something went wrong on this page
                </Typography>
                <Typography color="text.secondary" sx={{ mb: 4 }}>
                    Please reload. If it keeps happening, the rest of the site still works.
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                    <Button variant="contained" onClick={() => window.location.reload()}>Reload</Button>
                    <Button variant="outlined" component={RouterLink} to="/">Go to the home page</Button>
                </Box>
            </Box>
        );
    }
}

// A new boundary per page, so moving to another page clears the error.
const PageErrorBoundary = ({ children }) => {
    const { pathname } = useLocation();
    return <Boundary key={pathname}>{children}</Boundary>;
};

export default PageErrorBoundary;
